import { withTranslation } from 'react-i18next'
import Tasks from './Tasks'

export default withTranslation()(Tasks)
